import { Outlet } from 'react-router-dom';
import { Speaker } from 'lucide-react';

export default function AttendeeLayout() {
  return (
    <div className="min-h-screen bg-background-light dark:bg-background-dark">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm border-b border-gray-200 dark:border-gray-800">
        <div className="container mx-auto px-4 py-3 flex items-center gap-2">
          <Speaker className="w-6 h-6 text-primary" />
          <span className="font-bold text-lg">VoteBeats</span>
        </div>
      </header>

      {/* Main content */}
      <main className="container mx-auto">
        <Outlet />
      </main>
    </div>
  );
}
